import { ApiConstants } from '../../constants/actions';
import createReducer from '../../helpers/CreateReducer';

interface AddSignatoryRoleToUserState {
  isAdding: boolean;
}

export const getInitialState = (): AddSignatoryRoleToUserState => ({
  isAdding: false
});

export default createReducer(getInitialState, {
  [`${ApiConstants.ADD_SIGNATORY_ROLE_TO_USER}_REQUEST`]: (
    state: AddSignatoryRoleToUserState
  ) => ({
    ...getInitialState(),
    isAdding: true
  }),
  [`${ApiConstants.ADD_SIGNATORY_ROLE_TO_USER}_SUCCESS`]: (
    state: AddSignatoryRoleToUserState
  ) => ({
    ...state,
    isAdding: false
  }),
  [`${ApiConstants.ADD_SIGNATORY_ROLE_TO_USER}_FAILURE`]: (
    state: AddSignatoryRoleToUserState
  ) => ({
    ...getInitialState()
  })
});
